module.exports = __webpack_public_path__ + "img/star_half_empty.375c2a10.svg";